import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TimesheetPageState } from './states/TimesheetPageState';
import './timesheetInputCompletePane.module.scss';
import { ReservationPane } from '../../components/atoms/reservations/ReservationPane';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../routes';
import { CancellationPolicyForCoach } from './CancellationPolicyForCoach';

type Props = {
  pageState: TimesheetPageState;
};

export const TimesheetInputCompletePane = inject('pageState')(
  observer(
    class TimesheetInputCompletePane extends React.Component<Props> {
      render() {
        return (
          <ReservationPane styleName="pane">
            <div styleName="text">シフトの入力が完了しました</div>
            <div styleName="date">予約した日程は「シフト管理」のページから確認できます</div>
            <CancellationPolicyForCoach />
            <div styleName="button-wrapper">
              <Button
                styleName="button"
                type="primary"
                size="m"
                disabled={false}
                onClick={() => GlobalStatesV3.routing.push(V3Routes.timesheetHome())}
              >
                シフト管理ページへ戻る
              </Button>
            </div>
          </ReservationPane>
        );
      }
    }
  )
);
